<template>
  <div id="detailDiv" class="board-md">
    <div v-if="tabName === '3-0'">
      <Divider orientation="left">金额汇总数据<span
        v-if="dataMap.invalid_money">(剔除交易总金额：{{ Number(dataMap.invalid_money).toFixed(0) }})</span></Divider>
      <Table border highlight-row :columns="statBaseColumns" :data="dataMap.hz_sj"></Table>
      <Divider orientation="left" >日均余额数据</Divider>
      <Table border highlight-row :columns="dailyAvgColumns" :data="dataMap.bank_daily_avg_balance"></Table>
      <Divider orientation="left" v-if="dataMap.wages_info_summer">工资信息</Divider>
      <Table border highlight-row :columns="wagesInfoColumns" :data="dataMap.wages_info_summer"></Table>
      <Divider orientation="left" v-if="dataMap.pos_trade_summer">收单信息</Divider>
      <Table border highlight-row :columns="posTradeInfoColumns" :data="dataMap.pos_trade_summer"></Table>
      <Divider orientation="left">小额交易汇总数据（五千以下）</Divider>
      <Table border highlight-row :columns="statBaseColumns" :data="dataMap.hz_sj_wq_yx"></Table>
    </div>

    <div v-if="tabName === '3-1'">
      <Divider orientation="left" v-if="dataMap.bill_stat_weixin">微信汇总数据</Divider>
      <Table border highlight-row :columns="statBaseColumns" :data="dataMap.bill_stat_weixin"
             v-if="dataMap.bill_stat_weixin"></Table>
      <Divider orientation="left" v-if="dataMap.bill_stat_zhifubao">支付宝汇总数据</Divider>
      <Table border highlight-row :columns="statBaseColumns" :data="dataMap.bill_stat_zhifubao"
             v-if="dataMap.bill_stat_zhifubao"></Table>
      <Divider orientation="left" v-if="dataMap.bill_stat_bank">银行汇总数据</Divider>
      <Table border highlight-row :columns="statBaseColumns" :data="dataMap.bill_stat_bank"
             v-if="dataMap.bill_stat_bank"></Table>
      <Divider orientation="left">月度交易数据</Divider>
      <Table border highlight-row :columns="monthlySummaryColumns" :data="dataMap.monthlySummaryList"></Table>
    </div>

    <div v-if="tabName === '3-2'">
      <Divider orientation="left">司法相关交易</Divider>
      <Table border highlight-row :columns="tradeInfoColumns"
             :data="dataMap.judicial_trade_list"></Table>
      <Divider orientation="left">异常交易</Divider>
      <Table border highlight-row :columns="tradeInfoColumns"
             :data="dataMap.error_flow_list"></Table>
      <Divider orientation="left">高频转账交易</Divider>
      <Table border highlight-row :columns="highFrequencyTradeInfoColumns"
             :data="dataMap.high_frequency_transfer_list"></Table>
      <Divider orientation="left">夜间交易</Divider>
      <Table border highlight-row :columns="transferBaseColumns"
             :data="dataMap.night_trade_list"></Table>
      <Divider orientation="left">娱乐相关交易</Divider>
      <Table border highlight-row :columns="tradeInfoColumns"
             :data="dataMap.leisure_entertainment_list"></Table>
    </div>

    <div v-if="tabName === '3-3'">
      <Divider orientation="left" v-if="dataMap.credit_card_summary">卡交易数据</Divider>
      <Table border highlight-row :columns="cardBaseColumns" :data="dataMap.credit_card_summary"></Table>
      <Divider orientation="left" v-if="dataMap.repayment_summary">还款数据</Divider>
      <Table border highlight-row :columns="cardBaseColumns" :data="dataMap.repayment_summary"></Table>
    </div>

    <div v-if="tabName === '3-4'">
      <Divider orientation="left" v-if="dataMap.yueebao_daily_avg_balance">余额宝数据</Divider>
      <Table border highlight-row :columns="yuebaoColumns" :data="dataMap.yueebao_daily_avg_balance"></Table>
      <Divider orientation="left" v-if="dataMap.manage_money_trade_summer">理财数据</Divider>
      <Table border highlight-row :columns="manageMoneyColumns" :data="dataMap.manage_money_trade_summer"></Table>
    </div>

    <div v-if="tabName === '3-5'">
      <Divider orientation="left" v-if="dataMap.online_shopping_summary">电商消费数据</Divider>
      <Table border highlight-row :columns="onlineShoppingColumns" :data="dataMap.online_shopping_summary"></Table>
      <Divider orientation="left" v-if="dataMap.phone_monthly_summary">话费支出</Divider>
      <Table border highlight-row :columns="lifeColumns" :data="dataMap.phone_monthly_summary"></Table>
      <Divider orientation="left" v-if="dataMap.sdm_monthly_summary">水电煤支出</Divider>
      <Table border highlight-row :columns="lifeColumns" :data="dataMap.sdm_monthly_summary"></Table>
      <Divider orientation="left" v-if="dataMap.car_monthly_summary">汽车相关支出（包括：加油、停车）</Divider>
      <Table border highlight-row :columns="lifeColumns" :data="dataMap.car_monthly_summary"></Table>
      <Divider orientation="left" v-if="dataMap.travel_monthly_summary">出行旅游相关支出（包括：火车、飞机、酒店）
      </Divider>
      <Table border highlight-row :columns="lifeColumns" :data="dataMap.travel_monthly_summary"></Table>
    </div>

    <div v-if="tabName === '3-6'">
      <Divider orientation="left">转账汇总</Divider>
      <Table border highlight-row :columns="monthlySummaryColumns" :data="dataMap.transfer_monthly_summary"></Table>
      <Divider orientation="left">主要转账交易金额对手</Divider>
      <Table border highlight-row :columns="transferBaseColumns"
             :data="dataMap.transfer_counterparty_summary"></Table>
      <Divider orientation="left">主要转账交易次数对手</Divider>
      <Table border highlight-row :columns="transferBaseColumns"
             :data="dataMap.transfer_counterparty_count_summary"></Table>
    </div>

    <div v-if="tabName === '3-7'">
      <Divider orientation="left">主要消费对手交易</Divider>
      <Table border highlight-row :columns="payBaseColumns" :data="dataMap.pay_counterparty_count_summary"></Table>
      <Divider orientation="left">主要大额消费详情</Divider>
      <Table border highlight-row :columns="payDetailColumns" :data="dataMap.pay_counterparty_max_detail"></Table>
    </div>

    <div v-if="tabName === '3-8'">
      敬请期待......
    </div>
  </div>
</template>
<script>

export default {
  name: 'content-detail',
  props: {
    dataMap: {
      type: Object
    },
    tabName: String
  },
  data () {
    return {
      payDetailColumns: [{
        key: 'flowCard',
        className: 'table-header-cell-mb',
        renderHeader: (h, params) => {
          return h('div', [
            h('strong', '付款方式')
          ])
        }
      }, {
        key: 'counterparty',
        className: 'table-header-cell-mb',
        renderHeader: (h, params) => {
          return h('div', [
            h('strong', '交易对手')
          ])
        }
      }, {
        key: 'money',
        className: 'table-header-cell-mb',
        renderHeader: (h, params) => {
          return h('div', [
            h('strong', '金额')
          ])
        }
      }, {
        key: 'goodsDesc',
        className: 'table-header-cell-mb',
        renderHeader: (h, params) => {
          return h('div', [
            h('strong', '商品说明')
          ])
        }
      }],
      payBaseColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '交易对手')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '交易金额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '交易次数')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '排名')
            ])
          }
        }],

      statBaseColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '账单交易类型')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '金额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '笔数')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '年均')
            ])
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '月均')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell-mb',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '排名')
            ])
          }
        }],
      monthlySummaryColumns:
        [{
          key: 'statDesc',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '月份')
            ])
          }
        }, {
          key: 'income',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '收入')
            ])
          }
        }, {
          key: 'payout',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '支出')
            ])
          }
        }, {
          key: 'other',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '其他')
            ])
          }
        }, {
          key: 'notRecording',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '不计收入')
            ])
          }
        }],
      cardBaseColumns:
        [{
          key: 'cardNo',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '银行账户')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '金额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '笔数')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '年均')
            ])
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '月均')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell-mb',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '排名')
            ])
          }
        }],
      dailyAvgColumns:
        [{
          key: 'cardNo',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '银行卡')
            ])
          }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '日均')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell-mb',
          render: (h, params) => {
            return h('div', [
              h('strong', '近' + params.row.countData + '天')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '活跃天数')
            ])
          }
        }, {
          title: '排名',
          key: 'rankData',
          className: 'table-header-cell-mb',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '排名')
            ])
          }
        }],
      yuebaoColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '交易类型')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '日均金额')
            ])
          }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '日均生息')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '持有天数')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell-mb',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '排名')
            ])
          }
        }],
      manageMoneyColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '理财类型')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '交易总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '交易次数')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '买入金额')
            ])
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '卖出金额')
            ])
          }
        }],
      lifeColumns:
        [{
          key: 'statTime',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '交易月份')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '交易总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '交易次数')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '排名')
            ])
          }
        }],
      onlineShoppingColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '品牌')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '交易总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '交易次数')
            ])
          }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '件均消费')
            ])
          }
        }, {
          title: '月均消费',
          key: 'monthAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '月均消费')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '排名')
            ])
          }
        }],
      transferBaseColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '交易对手')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '交易总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '交易次数')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '收入')
            ])
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '支出')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '排名')
            ])
          }
        }],
      wagesInfoColumns:
        [{
          key: 'money',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '工资总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '发放次数')
            ])
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '月均工资')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '最高')
            ])
          }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '最低')
            ])
          }
        }, {
          title: '排名',
          key: 'rankData',
          className: 'table-header-cell-mb',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '排名')
            ])
          }
        }],
      posTradeInfoColumns:
        [{
          key: 'money',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '收单总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '累计月份')
            ])
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '月均收款')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '最高')
            ])
          }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '最低')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell-mb',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '排名')
            ])
          }
        }],
      tradeInfoColumns: [{
        key: 'counterparty',
        className: 'table-header-cell-mb',
        renderHeader: (h, params) => {
          return h('div', [
            h('strong', '交易对手')
          ])
        }
      }, {
        key: 'flowTime',
        className: 'table-header-cell-mb',
        renderHeader: (h, params) => {
          return h('div', [
            h('strong', '交易时间')
          ])
        }
      }, {
        key: 'flowType',
        className: 'table-header-cell-mb',
        renderHeader: (h, params) => {
          return h('div', [
            h('strong', '交易类型')
          ])
        }
      }, {
        key: 'flowDirection',
        className: 'table-header-cell-mb',
        renderHeader: (h, params) => {
          return h('div', [
            h('strong', '交易方向')
          ])
        }
      }, {
        key: 'money',
        className: 'table-header-cell-mb',
        renderHeader: (h, params) => {
          return h('div', [
            h('strong', '交易金额')
          ])
        }
      }, {
        key: 'balance',
        className: 'table-header-cell-mb',
        renderHeader: (h, params) => {
          return h('div', [
            h('strong', '金额')
          ])
        }
      }],
      highFrequencyTradeInfoColumns: [{
        key: 'counterparty',
        className: 'table-header-cell-mb',
        renderHeader: (h, params) => {
          return h('div', [
            h('strong', '交易对手')
          ])
        }
      }, {
        key: 'flowTime',
        className: 'table-header-cell-mb',
        render: (h, params) => {
          return h('div', [
            h('span', params.row.flowTime.slice(0, 10))
          ])
        },
        renderHeader: (h, params) => {
          return h('div', [
            h('strong', '交易时间')
          ])
        }
      }, {
        key: 'flowType',
        className: 'table-header-cell-mb',
        renderHeader: (h, params) => {
          return h('div', [
            h('strong', '交易次数')
          ])
        }
      }, {
        key: 'money',
        className: 'table-header-cell-mb',
        renderHeader: (h, params) => {
          return h('div', [
            h('strong', '交易金额')
          ])
        }
      }]
    }
  },
  mounted: function () {
    this.tabName = this.$parent.tabName
    this.setData(this.$parent.dataMap, this.$parent.homeStat)
  },
  methods: {
    setData (dataMap, homeStat) {
      this.homeStat = homeStat
      this.dataMap = this.getDataMap()
      this.dataMap = dataMap
    },
    getDataMap () {
      return {
        uploadLog: [],
        hz_sj: [],
        hz_sj_yw_yx: [],
        hz_sj_wq_yx: [],
        bill_stat_weixin: [],
        bill_stat_zhifubao: [],
        bill_stat_bank: [],
        monthlySummaryList: [],
        credit_card_summary: [],
        repayment_summary: [],
        yueebao_daily_avg_balance: [],
        manage_money_trade_summer: [],
        phone_monthly_summary: [],
        sdm_monthly_summary: [],
        car_monthly_summary: [],
        travel_monthly_summary: [],
        transfer_monthly_summary: [],
        transfer_counterparty_summary: [],
        transfer_counterparty_count_summary: [],
        transfer_counterparty_night_count_summary: [],
        judicial_trade_list: [],
        error_flow_list: [],
        leisure_entertainment_list: [],
        pay_counterparty_count_summary: [],
        pay_counterparty_max_detail: [],
        bank_daily_avg_balance: [],
        wages_info_summer: [],
        pos_trade_summer: [],
        online_shopping_summary: [],
        bank_balance_list: [],
        high_frequency_transfer_list: [],
        night_trade_list: []
      }
    }
  }
}
</script>
<style>
.dvd-font {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 10pt;
    color: #666666;
  }
.ivu-table th.table-header-cell-mb {
  background: #1242CD;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 10pt;
  color: #FFFFFF;
  text-align: center;
  border: #1242CD;
}
</style>
